import React from 'react';
import { ProjectContainer } from './Project';
import { updateActivity, setNoErrors, catchErrors } from '../middleware';

// Redux components
import { combineReducers, applyMiddleware, createStore } from 'redux';
import { Provider } from 'react-redux';
import middleware from 'redux-thunk';
import reducer from '../reducer';

const ProjectApp = (props) => {
  const combinedProps = reducer(undefined, {
    type: 'SET_STATE',
    state: props,
  });
  const store = applyMiddleware(middleware, updateActivity, catchErrors)(createStore)(reducer, combinedProps);

  return (
    <Provider store={store}>
      <ProjectContainer />
    </Provider>
  );
};

export default ProjectApp;
